import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  GetDepartment,
  ActiveDepartment,
  InactiveDepartment,
} from "../../../store/department-store/department-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";

const DepartmentDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const department = useSelector((state) => state.department.department);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (department.id === undefined || department.id === 0) {
      dispatch(GetDepartment(param.departmentId, userInfo.Email));
    }
  }, [param.departmentId, dispatch, department.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(ActiveDepartment(param.departmentId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveDepartment(param.departmentId, userInfo.Email));
  };
  let activeSuspend;
  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("department.active")
  ) {
    activeSuspend = (
      <div className="field col-12 md:col-3 mt-3">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "150px" }}
          label="Activar"
          className="p-button-success"
          onClick={activeHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-check"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }
  if (department.status) {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("department.inactive")
    ) {
      activeSuspend = (
        <div className="field col-12 md:col-3 mt-3">
          <Button
            rounded
            text
            raised
            style={{
              backgroundColor: "#fff",
              width: "150px",
            }}
            label="Suspender"
            className="p-button-warning"
            onClick={inactiveHandler}
            icon={
              notification && notification.status === "pending"
                ? "pi pi-spin pi-spinner"
                : "pi pi-times"
            }
            disabled={notification && notification.status === "pending"}
          />
        </div>
      );
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(department.id === undefined || department.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(department.id !== undefined || department.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{ borderBottom: "solid #fff", paddingBottom: "1.3%" }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {department.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Departamento
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12">
                <>
                  <label
                    style={{ color: "", fontSize: "large", fontWeight: "bold" }}
                  >
                    Descripción:{" "}
                  </label>
                  <label
                    style={{
                      color: "",
                      marginLeft: "1%",
                      fontSize: "large",
                    }}
                  >
                    {" "}
                    {department.description}
                  </label>
                </>
              </div>
              <div className="field col-12 md:col-3 mt-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/departments");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("department.edit") && (
                  <div className="field col-12 md:col-3 mt-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{
                        backgroundColor: "#fff",
                        width: "150px",
                      }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/departments/edit/${department.id}`);
                      }}
                    />
                  </div>
                )}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default DepartmentDetail;
